import OthersTable from '../components/others_table.vue'

export default {
  components: {
    OthersTable
  }
}